module.exports = __webpack_public_path__ + "static/logo-mobile-crypto-million-dfea3e49ab7c04979ffec69700250d08.png";